var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{on:{"click":function($event){return _vm.toBack()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }